import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomers } from "../redux/slices/Customer/customerReportSlice";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./GroupLoanLetters.css";
import axios from "axios";

const GroupLoanSanction = () => {
  const { loanId } = useParams();
  const dispatch = useDispatch();

  const { profile } = useSelector((state) => state.userProfile);

  const [loan, setLoan] = useState(null);
  const [guarantor, setGuarantor] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [company, setCompany] = useState(null);
  const [photoUrl, setPhotoUrl] = useState(null);
  const [signatureUrl, setSignatureUrl] = useState(null);

  const [branchSealUrl, setBranchSealUrl] = useState(null);
  const [branchSignUrl, setBranchSignUrl] = useState(null);

  const createdById = Number(localStorage.getItem("userId")) || 0;

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    const branchId = Number(localStorage.getItem("userId")) || 0;

    const loadData = async () => {
      try {
        const loanRes = await axios.get(
          `https://payyug.in/api/group-loan/group/list`,
          {
            params: {
              superAdminId: profile.superAdminId || 14,
              officerId: profile.id,
              limit: 1000,
            },
          },
        );
        const loanList = loanRes.data?.data || loanRes.data || [];
        const selectedLoan = loanList.find(
          (l) => String(l.id) === String(loanId),
        );

        if (!selectedLoan) {
          toast.error("Loan not found");
          return;
        }
        setLoan(selectedLoan);

        if (profile?.superAdminId) {
          const customerAction = await dispatch(
            fetchCustomers({
              page: 1,
              limit: 1000,
              superAdminId: profile.superAdminId,
            }),
          );

          const customerList =
            customerAction?.payload?.data ||
            customerAction?.payload ||
            customerAction?.data?.data ||
            [];
          const selectedCustomer = customerList.find(
            (c) =>
              String(c.userId).toLowerCase() ===
              String(selectedLoan?.member?.userId).toLowerCase(),
          );
          setCustomer(selectedCustomer);

          // console.log("selected cusoter",selectedCustomer)

          const companyRes = await fetch(
            `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`,
          );
          const companyData = await companyRes.json();
          if (companyRes.ok) {
            const companyInfo = companyData.data || companyData;
            if (companyInfo.logo) {
              companyInfo.logoUrl = `https://payyug.in/${companyInfo.logo.replace(/^images\//, "")}`;
            }
            setCompany(companyInfo);
          }

          if (selectedCustomer?.userId) {
            try {
              const kycRes = await fetch(
                `https://payyug.in/api/list-kyc?userId=${selectedCustomer.userId}&superAdminId=${profile.superAdminId}&createdId=${profile.id}`,
              );
              const kycData = await kycRes.json();
              if (kycRes.ok && kycData.documents?.length > 0) {
                const photoDoc = kycData.documents.find(
                  (doc) => doc.docName?.toLowerCase() === "photo",
                );
                const signDoc = kycData.documents.find(
                  (doc) => doc.docName?.toLowerCase() === "signature",
                );
                if (photoDoc?.docImage)
                  setPhotoUrl(`https://payyug.in/uploads/${photoDoc.docImage}`);
                if (signDoc?.docImage)
                  setSignatureUrl(
                    `https://payyug.in/uploads/${signDoc.docImage}`,
                  );
              }
            } catch (err) {
              console.error("KYC fetch error:", err);
            }
          }

          if (selectedLoan?.customer?.userId) {
            const nomRes = await fetch(
              `https://payyug.in/api/nominee-get-all?loanId=${loanId}&branchId=${branchId || 0}&customerId=${selectedLoan?.customer?.userId}`,
            );
            const nomData = await nomRes.json();
            if (
              nomRes.ok &&
              nomData.success &&
              Array.isArray(nomData.data) &&
              nomData.data.length > 0
            ) {
              setGuarantor(nomData.data[0]);
            }
          }
        }
      } catch (err) {
        console.error(err);
        toast.error(err?.response?.data?.message || "Error loading data");
      }
    };

    if (profile) loadData();
  }, [dispatch, loanId, profile, createdById]);


  
  useEffect(() => {
    const fetchSealSign = async () => {
      if (!profile?.superAdminId) return;

      try {
        const res = await axios.get(
          `https://payyug.in/api/list/stamp?superAdminId=${profile?.superAdminId}&category=Group Loan Sanction`
        );

        const dataArray = res?.data?.data?.[0] || [];


        if (dataArray && dataArray.file) {
          const cleanSealPath = dataArray.file.replace(/^images\//, "");
          setBranchSealUrl(`https://payyug.in/${cleanSealPath}`);
        } else {
          setBranchSealUrl(null);
        }

        if (dataArray && dataArray.type) {
          const cleanSignPath = dataArray.type.replace(/^images\//, "");
          setBranchSignUrl(`https://payyug.in/${cleanSignPath}`);
        } else {
          setBranchSignUrl(null);
        }

      } catch (error) {
        console.error("API Fetch Error:", error);
      }
    };

    fetchSealSign();
  }, [profile?.superAdminId]);

  const handleDownloadPDF = async () => {
    const button = document.querySelector(".gl-letters-print-btn-container");
    if (button) button.style.display = "none";
    const input = document.querySelector(".gl-letters-container");
    if (!input) return;
    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      logging: false,
    });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const imgWidth = 210;
    const pageHeight = 297;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
    while (heightLeft > pageHeight) {
      heightLeft -= pageHeight;
      pdf.addPage();
      pdf.addImage(
        imgData,
        "PNG",
        0,
        -imgHeight + heightLeft,
        imgWidth,
        imgHeight,
      );
    }
    pdf.save(`${loan.memberName ||loan?.member?.fullName||c?.fullName}_GroupLoanSanction.pdf`);
    if (button) button.style.display = "block";
  };

  if (!loan) return <p>Loading...</p>;

  const c = customer || {};
  const companyName = company?.name || "Techvision Company";
  const companyLogo = company?.logoUrl || "/logo.png";
  const companyCIN = company?.cin || "U88900AS2025NPL028600";
  const companyMobile = company?.contact || "0000000000";
  const companyEmail = company?.email || "xyz@gmail.com";
  const companyAddress =
    company?.address || "House No-4, Ahiyapur, Muzaffarpur, Bihar - 781014";
  const appliedDate = loan.loanAppliedDate
    ? new Date(loan.loanAppliedDate).toLocaleDateString("en-GB")
    : "-";

  return (
    <div className="gl-letters-container">
      <div className="gl-letters-header">
        <div className="gl-letters-logo-box">
          <img src={companyLogo} alt="logo" crossOrigin="anonymous" />
        </div>
        <div className="gl-letters-company-details">
          <h2>{companyName}</h2>
          <span>
            <strong>CIN:</strong> {companyCIN}
          </span>
          <span>
            <strong>Regt. Office:</strong> {companyAddress}
          </span>
          <span>
            <strong>Mobile:</strong> {companyMobile}
          </span>
          <span>
            <strong>Email:</strong> {companyEmail}
          </span>
        </div>
        <div className=""></div>
      </div>

      <h3 className="gl-letters-title">Group Loan Sanction Letter</h3>

      <table className="gl-letters-details-table">
        <tbody>
          <tr>
            <td>
              <strong>Branch Name:</strong> {profile?.branchName || "N/A"}
            </td>
            <td>
              <strong>Applied Date:</strong> {appliedDate}
            </td>
          </tr>
        </tbody>
      </table>

      <table className="gl-letters-details-table">
        <tbody>
          <tr>
            <td className="gl-letters-field-name">Group Name</td>
            <td className="gl-letters-field-value">{loan.groupName || "-"}</td>
            <td className="gl-letters-field-name">Center Name</td>
            <td className="gl-letters-field-value">{loan.centerName || "-"}</td>
            <td rowSpan="4" className="gl-letters-photo-box">
              <img
                src={photoUrl || "/user.png"}
                alt="customer"
                crossOrigin="anonymous"
              />
            </td>
          </tr>
          <tr>
            <td className="gl-letters-field-name">Member Name</td>
            <td className="gl-letters-field-value">{loan.memberName ||loan?.member?.fullName||c?.fullName|| "-"} </td>
            <td className="gl-letters-field-name">Guardian</td>
            <td className="gl-letters-field-value">{c?.guardianName ||loan?.member?.guardianName|| "-"}</td>
          </tr>
          <tr>
            <td className="gl-letters-field-name">District</td>
            <td className="gl-letters-field-value">{c.district ||loan?.member?.district||c?.fullName|| "-"} </td>
            <td className="gl-letters-field-name">Contact Number</td>
            <td className="gl-letters-field-value">{c?.mobileNumber ||loan?.member?.mobileNumber|| "-"}</td>
          </tr>
          <tr>
            <td className="gl-letters-field-name">Gender</td>
            <td className="gl-letters-field-value">{c.gender ||loan?.member?.gender|| "-"}</td>
            <td className="gl-letters-field-name">Date of Birth</td>
            <td className="gl-letters-field-value">
              {c.dateOfBirth||loan?.member?.dateOfBirth
                ? new Date(c.dateOfBirth||loan?.member?.dateOfBirth).toLocaleDateString("en-GB")
                : "-"}
            </td>
          </tr>
          <tr>
            <td className="gl-letters-field-name">Full Address</td>
            <td className="gl-letters-field-value" colSpan="4">
              {[c.address||loan?.member?.address, c.country||loan?.member?.country, c.pincode||loan?.member?.pincode].filter(Boolean).join(", ") ||
                "-"}
            </td>
          </tr>
        </tbody>
      </table>

      <h4 className="gl-letters-details-heading">Group Loan Details</h4>
      <table className="gl-letters-bank-table">
        <tbody>
          <tr>
            <td className="gl-letters-field-name">Account Number</td>
            <td className="gl-letters-field-value">{loan.loanAccountNumber || "-"}</td>
            <td className="gl-letters-field-name">Loan Amount</td>
            <td className="gl-letters-field-value">
              {loan.loanAmount ? `₹${loan.loanAmount.toLocaleString()}` : "-"}
            </td>
          </tr>
          <tr>
            <td className="gl-letters-field-name">Loan Type</td>
            <td className="gl-letters-field-value">{loan.loanType || "-"}</td>
            <td className="gl-letters-field-name">Amount to be Paid</td>
            <td className="gl-letters-field-value">{loan.loanPayable || "-"}</td>
          </tr>
          <tr>
            <td className="gl-letters-field-name">Interest Rate (%)</td>
            <td className="gl-letters-field-value">{loan.loanRoi || "-"}</td>
            <td className="gl-letters-field-name">Emi Amount</td>
            <td className="gl-letters-field-value">{loan.loanEmiAmount || "-"}</td>
          </tr>
        </tbody>
      </table>

      {/* <h4 className="gl-letters-details-heading">Guarantor Details</h4>
      <table className="gl-letters-guarantor-table">
        <tbody>
          <tr>
            <td className="gl-letters-field-name">Guarantor Name</td>
            <td className="gl-letters-field-value">{guarantor?.guarantorName || "-"}</td>
            <td className="gl-letters-field-name">Aadhaar No</td>
            <td className="gl-letters-field-value">{guarantor?.guarantorAadhar || "-"}</td>
            <td rowSpan="3" className="gl-letters-guarantor-photo-box">
              <img src={guarantor?.guarantorImage ? `https://payyug.in/uploads/${guarantor.guarantorImage}` : "/user.png"} alt="guarantor" crossOrigin="anonymous" />
            </td>
          </tr>
          <tr>
            <td className="gl-letters-field-name">Contact Number</td>
            <td className="gl-letters-field-value">{guarantor?.guarantorMobile || "-"}</td>
            <td className="gl-letters-field-name">PAN No</td>
            <td className="gl-letters-field-value">{guarantor?.panNumber || "-"}</td>
          </tr>
          <tr>
            <td className="gl-letters-field-name">Relation</td>
            <td className="gl-letters-field-value">{guarantor?.relationApplicant || "-"}</td>
          </tr>
        </tbody>
      </table> */}

      <table className="gl-letters-signature-table">
        <tbody>
          <tr>
            <td>
              Member Signature <br /> (सदस्य के हस्ताक्षर)
              <div className="border-line"></div>
              <div className="gl-letters-signature-area">
                {signatureUrl && signatureUrl.trim() !== "" ? (
                  <img
                    src={signatureUrl}
                    alt="Signature"
                    className="gl-letters-signature-img"
                    crossOrigin="anonymous"
                  />
                ) : (
                  <p>No Signature Upload</p>
                )}
              </div>
            </td>
            <td>
              Spouse Signature <br /> (जीवनसाथी के हस्ताक्षर) <div></div>
              <div className="border-line"></div>
            </td>
            <td>
              Branch Seal With Signature <br /> (शाखा मोहर) <div></div>
              <div className="border-line"></div>
              <div className="footer-seal-sign box-size">
               {branchSealUrl && (
              <div className="footer-seal">
                <img src={branchSealUrl} alt="Seal" />
              </div>
            )}
            
            {branchSignUrl && (
              <div className="footer-sign">
                <img src={branchSignUrl} alt="Signature" />
              </div>
            )}
            </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div className="gl-letters-print-btn-container">
        <button onClick={handleDownloadPDF}>Download PDF</button>
      </div>
    </div>
  );
};

export default GroupLoanSanction;
